import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: ""
}
const _hoisted_2 = {
  key: 1,
  style: {"font-size":".8rem"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "strong bi bi-arrow-right" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "strong bi bi-arrow-left" }, null, -1)
const _hoisted_7 = {
  key: 1,
  class: "text-primary"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-ui-checks" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_ctx.isStillLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-spinner'] }),
        _createTextVNode(" " + _toDisplayString(_ctx.language.loading) + "... ", 1)
      ]))
    : (_openBlock(), _createElementBlock("span", _hoisted_2, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.nbrInStock)), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.language.in_stock) + " ", 1),
        _hoisted_3,
        _hoisted_4,
        (_ctx.remainingToEntry > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.remainingToEntry)), 1),
              _createTextVNode("  " + _toDisplayString(_ctx.language.remaining) + " ", 1),
              _hoisted_6
            ]))
          : _createCommentVNode("", true),
        (_ctx.remainingToEntry == 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
              _createTextVNode(_toDisplayString(_ctx.language.fully_transf) + " ", 1),
              _hoisted_8
            ]))
          : _createCommentVNode("", true)
      ]))
}